<script>
export default {
    name: "VideoPlay2"
}
</script>
<template>
    <svg  role="img" aria-label="Video Play" width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="35" cy="35" r="35" fill="#D9D9D9"/>
        <path d="M45 33.2679C46.3333 34.0378 46.3333 35.9623 45 36.7321L31.5 44.5263C30.1667 45.2961 28.5 44.3338 28.5 42.7942L28.5 27.2058C28.5 25.6662 30.1667 24.7039 31.5 25.4737L45 33.2679Z" fill="#1C2326"/>
    </svg>
</template>
